import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { catchError, concat, concatMap, of, switchMap } from 'rxjs';
import { appEventActions } from '../../app-event';
import { sectionActions } from './section.action';
import { SectionService } from 'src/app/shared/services/settings/section';

@Injectable()
export class sectionEffects {
  constructor(
    private actions$: Actions,
    private sectionService: SectionService
  ) {}

  getAcademicYears$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sectionActions.getSections),
      concatMap(() =>
        concat(
          this.sectionService
            .getAll()
            .pipe(switchMap((data) => of(sectionActions.setSections({ data }))))
        )
      )
    )
  );

  create$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(sectionActions.create),
      switchMap((data) =>
        this.sectionService.create(data.data).pipe(
          switchMap(() => {
            data.onClose(true);
            return of(
              appEventActions.addToast({
                severity: 'success',
                detail: 'Section created successfully.',
              })
            );
          }),
          catchError((err) => {
            return of(appEventActions.handleError(err));
          })
        )
      )
    );
  });

  update$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(sectionActions.update),
      switchMap((data) =>
        this.sectionService.update(data.data, data.id).pipe(
          switchMap(() => {
            data.onClose(true);
            return of(
              appEventActions.addToast({
                severity: 'success',
                detail: 'Section updated successfully.',
              })
            );
          }),
          catchError((err) => {
            return of(appEventActions.handleError(err));
          })
        )
      )
    );
  });
}
